<template>
    <header class="header">
        <div class="wrapper">
            <router-link to="/"><img class="header__logo" src="@/assets/images/logo.png" alt="logo"></router-link>
            <div class="burger-menu" @click="menuHanlder()">
                <div>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            <main-nav class="main-menu" :class="{ 'menu-active': isMenuOpen }" :navItems="navItems"></main-nav>
        </div>
    </header>
</template>
  
<script>
import MainNav from "@/components/MainNav.vue";

export default {
    name: "VueHeader",

    components: {
        MainNav
    },

    data() {
        return {
            navItems: [
                {
                    path: 'new_buildings',
                    name: 'Новостройки'
                },
                {
                    path: 'favorite',
                    name: 'Избранное'
                },
                {
                    path: 'buying',
                    name: 'Как купить'
                },
                {
                    path: 'about',
                    name: 'О нас'
                }
            ],
            isMenuOpen: false
        }
    },

    methods: {
        menuHanlder() {
            this.isMenuOpen = !this.isMenuOpen
        }
    }
};
</script>
  
<style lang="scss">
.header {
    padding: 0;

    position: relative;
    z-index: 1;

    .burger-menu {
        display: none;
        width: 22px;
        height: 22px;
        position: absolute;

        right: 20px;
        top: 30px;

        >div {
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            min-height: 100%;

            span {
                display: block;
                content: "";

                width: 100%;
                height: 2px;
                border-radius: 2px;
                background-color: $font-color;

            }
        }
    }

    .wrapper {
        display: grid;
        grid-template-columns: 200px 1fr 200px;
        align-items: center;
    }

    &__logo {
        width: 100px;
        height: auto;
    }
}

@media screen and (max-width: 1200px) {
    .header {
        .wrapper {
            display: grid;
            grid-template-columns: 100px 1fr 100px;
            align-items: center;
        }
    }
}

@media screen and (max-width: 600px) {
    .header {
        padding-bottom: 10px;
        background-color: transparent;
        position: relative;

        transition: background-color .3s;

        &__logo {
            width: 100px;
        }

        .burger-menu {
            display: block;
        }

        .wrapper {
            display: grid;
            grid-template-columns: 1fr;
            align-items: center;

            >a {
                width: fit-content;
                justify-self: center;
            }
        }

        .main-menu {
            display: none;
            margin-top: 20px;
            padding-bottom: 10px;

            &.menu-active {
                display: block;
            }
        }
    }
}
</style>
  